import { render, staticRenderFns } from "./section-function.vue?vue&type=template&id=a48b0dee&scoped=true"
import script from "./section-function.vue?vue&type=script&lang=js"
export * from "./section-function.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48b0dee",
  null
  
)

export default component.exports